import * as React from "react";
import Autosuggest from "react-autosuggest";
import styled, { FlattenInterpolation } from "styled-components";
import colors from "../../../styles/colors";
import fontSizes from "../../../styles/fontSizes";
import theme from "../../../styles/theme";

interface IContainerProps {
  customStyles?: FlattenInterpolation<any>;
}

export const StyledAutosuggestContainer = styled.div<IContainerProps>`
  & div.react-autosuggest__suggestions-container {
    position: absolute;
    background: white;
    width: ${theme.maxWidth};
    ${({ customStyles }) => customStyles || ""}

    &.react-autosuggest__suggestions-container--open {
      border: 1px solid #ccc;
    }
    ul {
      list-style: none
      padding-left: 2rem;
      padding-right: 2rem;

      li:hover {
        background: ${colors.lightgrey};
        cursor: pointer;
        border-bottom: 1px solid #eee;
      }
    }
  }
  .react-autosuggest__input {
    color: ${colors.darkblue};
    font-size: ${fontSizes.regular};
  }
`;

export interface IAutocompleteProps<T> {
  fetchSuggestions: Autosuggest.SuggestionsFetchRequested;
  htmlName: string;
  initialValue?: string;
  customStyles?: FlattenInterpolation<any>;
  items: T[];
  itemValue: (item: T) => string;
  placeholderText?: string;
  renderInputComponent?: Autosuggest.RenderInputComponent;
  setSelected: (item: T) => void;
}

export interface IAutocompleteState<T> {
  inputValue: string;
  selected: T | null;
}

export default class AutoComplete<T> extends React.Component<IAutocompleteProps<T>, IAutocompleteState<T>> {
  constructor(props: IAutocompleteProps<T>) {
    super(props);
    this.state = {
      inputValue: props.initialValue || "",
      selected: null,
    };
  }

  public onChange = (_: React.FormEvent<any>, { newValue }: Autosuggest.ChangeEvent) => {
    this.setState({ inputValue: newValue });
  };

  public clearInput = () => {
    this.setState({ inputValue: "" });
  };

  public render() {
    const autoSuggestionInputProps: Autosuggest.InputProps<T> = {
      name: this.props.htmlName,
      onChange: this.onChange,
      placeholder: this.props.placeholderText,
      style: {
        border: `1px solid ${colors.grey}`,
        fontSize: `${fontSizes.large}`,
        marginBottom: `0.5rem`,
        padding: `0.5rem`,
        width: "calc(100% - 1.2rem)",
      },
      value: this.state.inputValue,
    };

    return (
      <StyledAutosuggestContainer customStyles={this.props.customStyles}>
        <Autosuggest<T>
          suggestions={this.props.items}
          inputProps={autoSuggestionInputProps}
          getSuggestionValue={this.props.itemValue}
          onSuggestionsFetchRequested={this.props.fetchSuggestions}
          renderSuggestion={this.props.itemValue}
          onSuggestionSelected={this.setSelected}
          onSuggestionsClearRequested={this.clearRequested}
          renderInputComponent={this.props.renderInputComponent}
        />
      </StyledAutosuggestContainer>
    );
  }

  private setSelected: Autosuggest.OnSuggestionSelected<T> = (event, data) => this.props.setSelected(data.suggestion);

  private clearRequested = () => null;
}
